/*
export interface ICommonObj {
  id: number;
  key: string;
  value: string;
  category?: string;
}

export class CCommonObj implements ICommonObj {
  public key = '';
  public value = '';
  public id = 0;
}

// gadgetの作成部分
export interface IGadgetBuild {
  target: ICommonObj[];
  measure: ICommonObj[];
  dimension: ICommonObj[];
  selectGraph: ICommonObj;
}

export class CGadgetBuild implements IGadgetBuild {
  public target = [] as any[];
  public measure = [] as any[];
  public dimension = [] as any[];
  public selectGraph = new CCommonObj();
}
*/

export interface IGadget<GADGET_DATA> {
  gadgetID: number;
  title: string;
  comment: string;
  gadget: string;
  options: object;
  default?: boolean;
  data: GADGET_DATA;
}


export class CGadget<GADGET_DATA> implements IGadget<GADGET_DATA> {
  public gadgetID = 0;
  public title = '';
  public comment = '';
  public measure = '';
  public gadget = '';
  public options = {};
  public data = {} as GADGET_DATA;
}
